// Deviation{days, basis, basisDate} -> render-ready label (RN22, D4).
//
// `days` at '' (the value detailApi.js maps `null` to) means "not computable" — the header
// paints the "deviation not computable" i18n literal, never "0 days" nor an "on time" text
// (P-3). Under the figure only the basis date is shown, never a cause (order/operation) — the
// contract has no such field on purpose (D4 (a)).
export const deviationLabel = (deviation) => {
  const source = deviation || {}
  const days = source.days === null || source.days === undefined ? '' : source.days
  const basisDate = source.basisDate === null || source.basisDate === undefined ? '' : source.basisDate

  if (days === '') {
    return { computable: false, days: '', basisDate: '' }
  }

  return { computable: true, days, basisDate }
}
